$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');


  // InfoBanner script
  $(window).load(function () {

    setTimeout(() => {
      
    if (($('#siteInfoBannerWidget #eventName').text().length) > 0) {
      $('#siteInfoBannerWidget #eventName').addClass('icon')
    }
    }, 800);

  })


  // Placeholder scripts
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')


  // NavBar border-radius script
  $('.groups .group').each(function () {

    $(this).find('.items > .item').each(function () {
      $(this).addClass('radius-class');

      $(this).find(".subitems > .item").each(function () {
        $(this).addClass(`radius-class`);
      });
    });

    $(this).find('.navClonedItem').removeClass('radius-class')
  });

  // TOGGLE
  $('.mobile-nav-toggle').append(`
    <div></div>
    <div></div>
    <div></div>
    `)

  // Tickets & Deals
  $('.ticket').text("Get Tickets")

  // Cart mobile
  $('.viewcart').clone().appendTo('.mobile-cart')

  // Custom lineup border
  $('.dynamicPageContainer .sectionHeading').each(function () {
    const text = $(this).text();
    if (text === '{picture-border}') {
      $(this).parent('.entityContainerRow').addClass('customImage');
      $(this).css('display', 'none')
    }
  })

  // Email Signup
  $('.footer .emailInputSubmit a').text('Sign Up')
  $('.footer .emailSignup input').attr('placeholder', 'Email Address')
  $('.footer .emailSignup input').val('')

});

$(window).load(function () {
  $(".saffireMobileSize #irishFestShop").insertBefore( $(".saffireMobileSize .mobile-cart"));
  // Weather Script
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});

$(document).ready(function(){
  $(".saffireMobileSize #irishFestShop").insertBefore( $(".saffireMobileSize .mobile-cart"));
});
$(window).resize(function(){
  $(".saffireMobileSize #irishFestShop").insertBefore( $(".saffireMobileSize .mobile-cart"));
});